import { render, staticRenderFns } from "./ChartRehabContainerCMJGeneralParameters.vue?vue&type=template&id=650e12c8&scoped=true&"
import script from "./ChartRehabContainerCMJGeneralParameters.vue?vue&type=script&lang=ts&"
export * from "./ChartRehabContainerCMJGeneralParameters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e12c8",
  null
  
)

export default component.exports